import * as yup from "yup";
import { CONSTANT } from "../../../shared/constants/constant-data";

export const loginValidationSchema = yup.object().shape({
  username: yup
    .string()
    .required(CONSTANT.AUTHENTICATION.USER_NAME_REQUIRED)
    .email(CONSTANT.AUTHENTICATION.USER_NAME_EMAIL)
    .matches(
      CONSTANT.AUTHENTICATION.AUTH_EMAIL_PATTERN,
      CONSTANT.AUTHENTICATION.USER_NAME_EMAIL
    )
    .max(64, CONSTANT.AUTHENTICATION.USER_NAME_MAX_LENGTH),

  password: yup
    .string()
    .required(CONSTANT.AUTHENTICATION.LOG_IN_PASSWORD_REQUIRED)
    .min(12, CONSTANT.AUTHENTICATION.AUTH_PASSWORD_MIN_LENGTH)
    .max(20, CONSTANT.AUTHENTICATION.AUTH_PASSWORD_MAX_LENGTH)
    .matches(/^\S*$/, CONSTANT.AUTHENTICATION.AUTH_PASSWORD_NO_SPACE),

  recaptcha: yup.string(),
  offlineCaptcha: yup.string(),
});
